import { styled } from 'styled-components';

export const PaginationContainer = styled.div`
  padding-bottom: ${({ theme }) => theme.sizing.medium};
  padding-right: ${({ theme }) => theme.sizing.medium};
`;

PaginationContainer.displayName = 'PaginationContainer';
